export default __webpack_public_path__ + "static/media/icon-user-premium.7b661722.svg";